import React from "react";

const Pagination = ({ activePg, setActivePg }) => {
  return (
    <div className="product_page_pagination">
      {[1, 2, 3, 4, 5].map((item) => (
        <div
          key={item}
          onClick={() => setActivePg(item)}
          className={activePg === item ? "active roboto" : "roboto"}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default Pagination;
